<template>
    <span fluid>
        <btn_component_avatar_icon :data="data" :icon="icon" :tooltip="tooltip" :size="size" :color="color" :disabled="disabled" @actionClick="actionClick" v-if="type==='avatar_icon'"/>
        <btn_component_avatar_text :data="data" :text="text" :tooltip="tooltip" :size="size" :color="color" :disabled="disabled" @actionClick="actionClick" v-if="type==='avatar_text'"/>
        <btn_component_icon        :data="data" :icon="icon" :tooltip="tooltip" :size="size" :color="color" :disabled="disabled" @actionClick="actionClick" v-if="type==='icon'"/>
        <btn_component_text        :data="data" :text="text" :tooltip="tooltip" :size="size" :color="color" :disabled="disabled" :icon="icon" @actionClick="actionClick" v-if="type==='text'"/>
    </span>
</template>

<script>
    import btn_component_avatar_icon from "@/components/ui/buttons/btn_component_avatar_icon.vue";
    import btn_component_avatar_text from "@/components/ui/buttons/btn_component_avatar_text.vue";
    import btn_component_icon from "@/components/ui/buttons/btn_component_icon.vue";
    import btn_component_text from "@/components/ui/buttons/btn_component_text.vue";

    export default {
        components: {
            btn_component_avatar_icon,
            btn_component_avatar_text,
            btn_component_icon,
            btn_component_text,
        },
        props: {
            type: {
                type: String,
                required: true,
            },
            data: {
                required: true,
            },
            icon: {
                type: String,
                required: false,
                default: "",
            },
            text: {
                type: String,
                required: false,
                default: "",
            },
            tooltip: {
                type: String,
                required: false,
                default: "Click me",
            },
            size: {
                type: String,
                required: false,
                default: "default",
            },
            color: {
                type: String,
                required: false,
                default: "primary",
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return {
            }
        },  
        methods: {
            actionClick() {
                this.$emit("actionClick", this.data);
            },
        },
    }
</script>

<style scoped>
    .action {
        cursor: pointer;
    }
</style>